module.exports = __webpack_public_path__ + "img/right_arrow.93703f88.svg";